<template>
  <div
    @click="bcMenuStore.closeMenu()"
    class="LeftNavMobileOverlay animate__animated animate__fadeIn animate__faster print:hidden print-hidden"
  ></div>

  <div class="LeftNavMobile print:hidden print-hidden">
    <div class="flex flex-col h-full">
      <slot />
      <div>
        <bc-footer-mobile />
      </div>
    </div>
  </div>
</template>

<script>
import useBcMenu from '@/frontapp/store/bcMenu'
import { mapStores } from 'pinia'

export default {
  computed: {
    ...mapStores(useBcMenu)
  },
}
</script>

<style lang="scss">
.LeftNavMobileOverlay {
  @apply bg-black bg-opacity-70 fixed z-10 left-0 right-0;
  top: 40px;
  bottom: 0px;
  z-index: 510;
}
.LeftNavMobile {
  @apply bg-white fixed  w-full shadow;
  max-width: 250px;
  right: 0;
  top: 40px;
  bottom: 0px;
  z-index: 511;

  .LeftNav__Item {
    a {
      @apply pl-5;

      span:first-child + span {
        @apply block;
        @apply ml-1;
      }
    }
  }
}
</style>
